// extracted by mini-css-extract-plugin
export default {"previewPanel":"preview-panel_previewPanel__iEshY"};